export const Routes = {
    home: '/',
    checkout: '/payment/checkout',
    cart: '/payment/cart',
    orderSuccess: '/payment/success',
    orderFailed: '/payment/failed',
    paymentForwarding: '/payment/forwarding',
    checkoutSuccess: '/payment/success',
    checkoutDigital: '/checkout/digital',
    checkoutGuest: '/checkout/guest',
    profile: '/profile',
    changePassword: '/change-password',
    orders: '/orders',
    order: (tracking_number: string) => `/orders/${encodeURIComponent(tracking_number)}`,
    refunds: '/refunds',
    help: '/help',
    logout: '/logout',
    coupons: '/offers',
    orderReceived: '/order-received',
    products: '/products',
    product: (slug: string) => {
        // if (asPath) {
        //   return `/products/${encodeURIComponent(slug)}?type=${asPath}`;
        // }
        return `/${encodeURIComponent(slug)}`;
    },
    privacy: '/privacy',
    terms: '/terms',
    contactUs: '/contact',
    shops: '/shops',
    cards: '/cards',
    shop: (slug: string) => `/shops/${encodeURIComponent(slug)}`,
    downloads: '/downloads',
    authors: '/authors',
    author: (slug: string) => `/authors/${encodeURIComponent(slug)}`,
    manufacturers: '/manufacturers',
    manufacturer: (slug: string) => `/manufacturers/${encodeURIComponent(slug)}`,
    search: '/search',
    wishlists: '/wishlists',
    questions: '/questions',
    reports: '/reports',
    flashSale: '/flash-sale',
    customer: '/customer',
    couponWallet: '/customer/coupon-wallet',
    salesOrderHistory: `/sales/order/history/`,
    hotPromotions: `/khuyen-mai-hot.html`,
    storeSystem: `/he-thong-cua-hang.html`,
    deliveryMethod: `/phuong-thuc-giao-hang`,
    returnRegulations: `/quy-dinh-doi-tra-hang`,
    memberIncentives: `/uu-dai-thanh-vien.html`,
    questionAndAnswer: `/hoi-dap.html`,
    highlightProducts: `/san-pham-noi-bat`,
    productsSuggestion: '/san-pham-danh-rieng-cho-ban',
    blog: 'https://www.kidsplaza.vn/blog/',
    storeNearYou: '/mua-nhanh-gan-nha.html',
    appDownload: '/tai-app-mobile',
    paymentMethod: '/phuong-thuc-thanh-toan',
    warrantyPolicy: '/chinh-sach-bao-hanh',
    contact: '/lien-he',
    privacyPolicy: '/chinh-sach-bao-mat',
    aboutUs: '/gioi-thieu-kidsplaza',
    festival: '/festival2025',
    registerFestival: '/dang-ky-festival2025',
    bestSeller: '/san-pham-ban-chay',
    newArrival: '/san-pham-moi',
    vnpayGuide: '/huong-dan-thanh-toan-vnpay',
    auth: '/auth',
};

// Should use Routes.customer prefix
// Ex: customer/info: ${Routes.customer}/${CustomerRoutes.info}
export const CustomerRoutes = {
    info: 'info',
    orders: 'orders',
    address: 'address',
    unReviewProducts: 'un-review-products',
    recentlyViewed: 'recently-viewed',
    wishlist: 'wishlist',
    buyLater: 'buy-later',
    review: 'review',
    faq: 'faq',
    amRewards: 'am-rewards',
    couponWallet: 'coupon-wallet',
    orderDetail: (tracking_number: string) => `${Routes.customer}/orders/${encodeURIComponent(tracking_number)}`,
};
